import React from 'react';
import MainPaymentServicePolicy from '../../components/Main/MainPolicy/MainPaymentServicePolicy';

export default function PaymentServicePolicy(){
    return(
        <div>
           <MainPaymentServicePolicy />
        </div>
    )
}
